export class RequestHeadCountDto {
  type: string;
}

export class RequestReportSendEmailExcelDto {
  type: string;
  emailTo: string;
  fullName: string;
}

export class RequestReportSendEmailPdfDto {
  type: string;
  emailTo: string;
  fullName: string;
}

export interface ResponseSendMailDto {
  message: string;
  data?: any;
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/head-count-report.dto.ts